import React, { Component } from 'react';
import moment from 'moment';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { isIOS } from '../util';
import DropdownInputBar from '../dropdown-input-bar';
import Calendar from '../calendar';
import './date-picker.css';

class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onDateInputChange = this.onDateInputChange.bind(this);
    this.onCalendarInputChange = this.onCalendarInputChange.bind(this);
    this.state = { isOpen: false };
  }

  open() {
    if (isIOS()) return;
    this.setState({ isOpen: true });
  }

  close() {
    this.setState({ isOpen: false });
  }

  onDateInputChange(e) {
    this.props.setEventDate(moment(e.target.value));
  }

  onCalendarInputChange(date) {
    this.props.setEventDate(moment(date));
  }

  render() {
    const { isOpen } = this.state;
    const {
      text,
      selectingType,
      otherType,
      setEventDate,
      startDate,
      endDate
    } = this.props;
    const formattedText = moment(text).format(`MMMM Do YYYY`);
    const initialValue = moment(this.props[selectingType]).format();
    const max = selectingType === 'startDate' && moment(endDate).format();
    const min = selectingType === 'endDate' && moment(startDate).format();
    console.log(initialValue);
    return (
      <div>
        <div style={{ marginBottom: '8px' }}>
          {isIOS()
            ? <DropdownInputBar
                onClick={this.open}
                iconName="calendar"
                text={formattedText}
              >
                <input
                  className="hidden-input"
                  type="datetime-local"
                  value={initialValue}
                  onChange={this.onDateInputChange}
                  max={max}
                  min={min}
                />
              </DropdownInputBar>
            : <Calendar
                onChange={this.onCalendarInputChange}
                value={initialValue}
                startDate={startDate}
                endDate={endDate}
                selectingType={selectingType}
              />}
        </div>
      </div>
    );
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./src/components/date-picker/index.js